import { computed, reactive } from 'vue'
import { helpers } from '@vuelidate/validators'

  class InfoAdicionalValidacion {
  
    public ObtenerReglasValidacion() {

      const applicationDefault = 'application/default';

      const documentosIdentidad: Archivo = {
        ExtensionesArchivos: [{
          Id: 0,
          Extension: applicationDefault
        }],
      }

      const certificados: Archivo = {
        ExtensionesArchivos: [{
          Id: 0,
          Extension: applicationDefault
        }],
      }   

      const formData = new FormData();
  
      const objetoArchivos = reactive({
        DocumentosIdentidad: documentosIdentidad,
        Certificados: certificados,
        Archivos: formData,
        TamañoArchivo: 0,
        NombresArchivos: [{
          Id: 0,
          Nombre: ''
        }],
        BuenasPracticas: '',
        DeclaracionJuradaVeracidad: false,
      });
  
      const maximoTamañoArchivo: number = 20971520;
  
      const ValidarLongitud = (TamañoArchivo: number) =>
        helpers.withParams({
            type: 'TamañoArchivo',
            value: TamañoArchivo
          },
          (TamañoArchivo: number) => !(TamañoArchivo > maximoTamañoArchivo)
        )
      
        const ValidarObligatorio = (objeto: Extension[]) =>
        helpers.withParams({
            type: 'objeto',
            value: objeto
          },
          (objeto: Extension[]) => (objeto.length > 1)
        )
  
      const ValidarExtension = (extensionesArchivo: Extension[]) =>
        helpers.withParams({
            type: 'extensionesArchivo',
            value: extensionesArchivo
          },
  
          (archivos: Extension[]) =>
  
          !(archivos.filter(archivo =>
            archivo.Extension != 'image/jpeg' &&
            archivo.Extension != 'image/png' &&
            archivo.Extension != 'application/pdf' &&
            archivo.Extension != 'application/default').length > 0)
        );
      
      const ValidarNombre = (NombresArchivos: Nombre[]) =>
        helpers.withParams({
            type: 'NombresArchivos',
            value: NombresArchivos
          },
  
          (archivos: Nombre[]) =>
  
          (
            (archivos.find((objetoNombreArchivo: Nombre, indice: number) => {
            return archivos.find((file: Nombre, index: number) =>
              objetoNombreArchivo.Nombre === file.Nombre && indice !== index)
          })) === undefined)
        );
      
      const ValidarAceptacionDeclaracion = (declaracionAceptada: boolean) =>
        helpers.withParams({
          type: 'declaracionAceptada',
          value: declaracionAceptada
        },
          (declaracionAceptada: boolean) => declaracionAceptada === true
        )
  
      const errorTamaño = 'El tamaño no puede superar 20MB';
      const errorExtension = 'La extensión válida de tus archivos es ( PNG,JPEG,PDF )';
      const errorObligatorio = 'Debes adjuntar al menos un archivo'
      const errorNombreDuplicado = 'Asegúrate de que tus archivos no contengan el mismo nombre';
      const errorDeclaracion = 'Debes aceptar la declaración juramentada de la veracidad de la información';
          
      const reglasValidacion = computed(() => {
        return {
          TamañoArchivo: {
            tamaño: helpers.withMessage(errorTamaño, ValidarLongitud(objetoArchivos.TamañoArchivo))
          },
          NombresArchivos: {
            nombre: helpers.withMessage(errorNombreDuplicado, ValidarNombre(objetoArchivos.NombresArchivos))
          },
          DocumentosIdentidad: {
            ExtensionesArchivos: {
              extension: helpers.withMessage(errorExtension, ValidarExtension(objetoArchivos.DocumentosIdentidad.ExtensionesArchivos)),
              obligatorio: helpers.withMessage(errorObligatorio, ValidarObligatorio(objetoArchivos.DocumentosIdentidad.ExtensionesArchivos))
            },
          },
          Certificados: {
            ExtensionesArchivos: {
              extension: helpers.withMessage(errorExtension, ValidarExtension(objetoArchivos.Certificados.ExtensionesArchivos)),
              obligatorio: helpers.withMessage(errorObligatorio, ValidarObligatorio(objetoArchivos.Certificados.ExtensionesArchivos))
            }
          },
          DeclaracionJuradaVeracidad: {
            aceptacion: helpers.withMessage(errorDeclaracion, ValidarAceptacionDeclaracion(objetoArchivos.DeclaracionJuradaVeracidad))
          },
        }
      });
  
        return [objetoArchivos, reglasValidacion] as const;
    }
  }
  
  export default InfoAdicionalValidacion;
